function itemSerializer() {
  return '{{item}}';
}

export function voucherSerializer() {
  return '{{voucher}}';
}

export default itemSerializer;
